import { useCallback, useEffect, useState } from 'react'
import { Howl } from 'howler'
import { usePrevious } from '../hooks'

export const useCrossfadedLoop = (urls, start, activeSound, stopAll, crossfadeDuration = 3000, volume = 1) => {
  const [activeSoundLoaded, setActiveSoundLoaded] = useState(false)
  const [loadedSoundsCount, setLoadedSoundsCount] = useState(0)
  const [activeSound2Loaded, setActiveSound2Loaded] = useState(false)
  const [sounds] = useState(() =>
    urls.map(
      (url, i) =>
        new Howl({
          src: url,
          volume: 0,
          html5: activeSound === 0 ? !i || i > 2 : true,
          onload: () => {
            if (
              (activeSound === 0 && i <= 2) ||
              (activeSound === 8 && i >= 6) ||
              activeSound === i + 1 ||
              activeSound === i - 1 ||
              activeSound === i
            ) {
              setLoadedSoundsCount((prev) => prev + 1)
            }
          },
        })
    )
  )

  useEffect(() => {
    if (loadedSoundsCount === 3) {
      setActiveSoundLoaded(true)
      console.log('3 first files loaded')
    }
  }, [loadedSoundsCount])

  const [sounds2] = useState(() =>
    urls.map(
      (url, i) =>
        new Howl({
          src: url,
          volume: 0,
          preload: false,
          html5: true,
          onload: () => {
            if (i === urls.length - 1) {
              console.log('rooms sounds 2 loaded')
              setActiveSound2Loaded(true)
            }
          },
        })
    )
  )

  // const unload = (soundsVar) => {
  //   var self = soundsVar
  //   console.log(soundsVar)
  //
  //   // Stop playing any active sounds.
  //   var sounds = self._sounds
  //   for (var i = 0; i < sounds.length; i++) {
  //     // Stop the sound if it is currently playing.
  //     if (!sounds[i]._paused) {
  //       self.stop(sounds[i]._id)
  //     }
  //
  //     // Remove the source or disconnect.
  //     if (!self._webAudio) {
  //       // Set the source to 0-second silence to stop any downloading (except in IE).
  //       self._clearSound(sounds[i]._node)
  //
  //       // Remove any event listeners.
  //       sounds[i]._node.removeEventListener('error', sounds[i]._errorFn, false)
  //       sounds[i]._node.removeEventListener(Howler._canPlayEvent, sounds[i]._loadFn, false)
  //
  //       // Release the Audio object back to the pool.
  //       Howler._releaseHtml5Audio(sounds[i]._node)
  //     }
  //
  //     // Empty out all of the nodes.
  //     delete sounds[i]._node
  //
  //     // Make sure all timers are cleared out.
  //     self._clearTimer(sounds[i]._id)
  //   }
  //
  //   // Remove the references in the global Howler object.
  //   var index = Howler._howls.indexOf(self)
  //   if (index >= 0) {
  //     Howler._howls.splice(index, 1)
  //   }
  //
  //   // Delete this sound from the cache (if no other Howl is using it).
  //   // if (!dontRemoveCache) {
  //   var remCache = true
  //   for (i = 0; i < Howler._howls.length; i++) {
  //     if (Howler._howls[i]._src === self._src || self._src.indexOf(Howler._howls[i]._src) >= 0) {
  //       remCache = false
  //       break
  //     }
  //     // }
  //
  //     // if (cache && remCache) {
  //     //   delete cache[self._src]
  //     // }
  //   }
  //
  //   // Clear global errors.
  //   Howler.noAudio = false
  //
  //   // Clear out `self`.
  //   self._state = 'unloaded'
  //   self._sounds = []
  //   self = null
  //
  //   return null
  // }

  useEffect(() => {
    if (activeSoundLoaded) {
      sounds2.map((sound) => sound.load())
    }
  }, [activeSoundLoaded, sounds2])

  useEffect(() => {
    console.log(activeSound2Loaded, 'sound2 loaded')
  }, [activeSound2Loaded])

  const prevSoundActive = usePrevious(activeSound)

  useEffect(() => {
    return () => {
      clearTimeout(window[`timerId${0}`])
      clearTimeout(window[`timerId${1}`])
      clearTimeout(window[`timerId${2}`])
      clearTimeout(window[`timerId${3}`])
      clearTimeout(window[`timerId${4}`])
      clearTimeout(window[`timerId${5}`])
      clearTimeout(window[`timerId${6}`])
      clearTimeout(window[`timerId${7}`])
      clearTimeout(window[`timerId${8}`])
      sounds[activeSound].fade(1, 0, crossfadeDuration)
      setTimeout(() => {
        sounds[activeSound].unload()
      }, crossfadeDuration)
    }
  }, [activeSound])

  const stopPrevSound = useCallback(
    (stopAll) => {
      console.log(stopAll, 'stop all rooms sounds', activeSound)
      clearTimeout(window[`timerId${activeSound + 1}`])
      clearTimeout(window[`timerId${activeSound - 1}`])
      let soundToStop = prevSoundActive > activeSound ? activeSound + 1 : activeSound - 1
      console.log(prevSoundActive, activeSound, soundToStop)

      // prevSoundActive.current = Howler._howls.find((howl) => !!Object.keys(howl._endTimers)[0])
      if (sounds[soundToStop] || sounds2[soundToStop]) {
        sounds[soundToStop].fade(1, 0, crossfadeDuration)
        sounds2[soundToStop].fade(1, 0, crossfadeDuration)
        setTimeout(() => {
          console.log('test stop')
          sounds[soundToStop].stop()
          sounds2[soundToStop].stop()
          // if (stopAll) {
          //   console.log(prevSoundActive.current, 'stop all unload')
          //   // unload()
          // }
        }, crossfadeDuration)
      }
    },
    [crossfadeDuration, activeSound, sounds, sounds2]
  )

  useEffect(() => {
    stopPrevSound()
  }, [activeSound, crossfadeDuration, stopPrevSound])

  useEffect(() => {
    if (stopAll) {
      stopPrevSound(stopAll)
    }
  }, [stopAll, stopPrevSound])

  useEffect(() => {
    const crossfadedLoop = (enteringInstance, leavingInstance) => {
      if (enteringInstance) {
        // Fade in entering instance
        enteringInstance.fade(0, volume, crossfadeDuration)
        enteringInstance.play()

        // Wait for the audio end to fade out entering instance
        // white fading in leaving instance
        window[`timerId${activeSound}`] = setTimeout(() => {
          enteringInstance.fade(volume, 0, crossfadeDuration)
          crossfadedLoop(leavingInstance, enteringInstance)
        }, enteringInstance._duration * 1000 - crossfadeDuration)
      }
    }

    if (start && activeSoundLoaded) {
      crossfadedLoop(sounds[activeSound], sounds2[activeSound])
    }
  }, [start, activeSoundLoaded, activeSound, sounds, sounds2, crossfadeDuration, volume])

  return {
    activeSoundsLoaded: activeSoundLoaded,
  }
}
